import { Component, Input } from '@angular/core';

@Component({
  selector: 'ebo-section-header',
  templateUrl: './ebo-section-header.component.html',
  styleUrls: ['./ebo-section-header.component.scss']
})
export class EboSectionHeaderComponent {
  @Input() title: string;
  @Input() subtitle: string;
}
